import { render, staticRenderFns } from "./LoginVerifyPhone.vue?vue&type=template&id=514d6cf3"
import script from "./LoginVerifyPhone.vue?vue&type=script&lang=ts"
export * from "./LoginVerifyPhone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports